module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page--section"
  }, [_c('header-bar-mobile'), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('header-bar')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "appear": "",
      "name": "title"
    }
  }, [_c('heading', {
    attrs: {
      "type": "h1"
    }
  }, [_vm._t("title")], 2)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "appear": "",
      "name": "content"
    }
  }, [_c('div', {
    staticClass: "page--content"
  }, [_vm._t("section")], 2)])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "appear": "",
      "name": "fromOpacity"
    }
  }, [_c('div', {
    staticClass: "page--aside"
  }, [_c('sticky', [_vm._t("aside")], 2)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cb5c2b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page.vue
// module id = 127
// module chunks = 0